import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/purvanchal/mainFeed.jpg'
import logo from '../../../assets/purvanchal/logo.webp'

import interior1 from '../../../assets/purvanchal/interior-1.png'
import interior2 from '../../../assets/purvanchal/interior-2.webp'
import interior3 from '../../../assets/purvanchal/interior-3.webp'
import interior4 from '../../../assets/purvanchal/interior-4.webp'
import interior5 from '../../../assets/purvanchal/interior-5.webp'

import ameneties1 from '../../../assets/purvanchal/ameneties-1.jpg'
import ameneties2 from '../../../assets/purvanchal/ameneties-2.jpg'
import ameneties3 from '../../../assets/purvanchal/ameneties-3.jpg'
import ameneties4 from '../../../assets/purvanchal/ameneties-4.webp'
import ameneties5 from '../../../assets/purvanchal/ameneties-5.webp'


import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';

const Purvanchal = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const interiors = [interior1, interior2, interior3, interior4, interior5]
    const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="relative w-full sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[500px] overflow-hidden rounded-lg">
                    <img
                        src={logo}
                        alt="logo"
                        className="w-full h-auto object-contain"
                    />
                </div>
            </div>


            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Purvanchal Projects has unveiled an exciting new residential development located in Sector 22D
                                along the Yamuna Expressway in Greater Noida. This project is designed to offer a blend of luxury,
                                comfort, and modern living, catering to diverse lifestyle needs.
                            </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Highlights:</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Prime Location:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Situated near the upcoming Jewar International Airport, this project ensures
                                        seamless connectivity to Delhi, Agra, and other NCR regions. It is also close to key infrastructures like
                                        IT hubs, schools, hospitals, and shopping centers.
                                    </p>
                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Eco-Friendly Design:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project incorporates sustainable features such as rainwater
                                        harvesting, energy-efficient systems, and green landscaping, promoting harmony with nature.                                     </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Modern Amenities :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Residents can enjoy a range of facilities, including a clubhouse, swimming
                                        pool, indoor and outdoor sports facilities, a dedicated kids' play area, and smart home automation
                                        systems.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Security :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Advanced security systems with 24x7 surveillance ensure peace of mind for residents.
                                    </p>
                                </div>
                            </section>

                            <h2 className="text-2xl md:text-3xl font-bold my-2"> Residential Options :</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project offers thoughtfully designed 2, 3, and 4 BHK apartments, each showcasing meticulous
                                        craftsmanship and state-of-the-art architecture. These homes are equipped with smart automation
                                        systems, allowing residents to control lighting, temperature, and security with ease.
                                    </p>
                                </div>
                            </section>
                            <h2 className="text-2xl md:text-3xl font-bold my-2"> Development Details :</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Purvanchal Projects acquired a 48,564 square meter land parcel in Sector 22D by the Yamuna
                                        Expressway Industrial Development Authority (Yeida). The project is currently in the pre-launch
                                        phase. </p>
                                </div>
                            </section>

                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                This development promises to redefine contemporary living with its strategic location, eco-friendly
                                design, and luxurious amenities. It is an ideal choice for those seeking a modern and comfortable
                                lifestyle in the heart of Greater Noida.
                            </p>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="max-w-7xl mx-auto">
                <h2 className="text-2xl font-semibold text-gray-800 m-4">
                    Luxury  Insights
                </h2>
                {openImgModal && activeImageType === "interiors" && (
                    <ImageModal
                        images={interiors}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                    {interiors.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "interiors")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Purvanchal